export default __webpack_public_path__ + "static/media/page1-img_05_original.2cd8b7a5.jpg";